import React from 'react';
import {
  Modal,
  Flex,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  FormControl,
  FormLabel,
  Input,
  useDisclosure,
  Button,
  useToast,
  Select,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import TicketApi from 'api/ticket';
import { ServiceTicketValidationSchema } from 'formValidations/serviceTicketFormValidations';

export default function PopModal(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const toast = useToast();

  const CloseModal = () => {
    formik.resetForm();
    onClose();
  };

  const formik = useFormik({
    initialValues: {
      subject: '',
      message: '',
      phoneNumber: props.customerPhoneNumber || '',
      priority: 'LOWEST',
      status: 'OPEN',
    },
    validationSchema: ServiceTicketValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const api = await TicketApi.Create({
          subject: values.subject,
          message: values.message,
          phone_number: String(values.phoneNumber),
          status: values.status,
          priority: values.priority,
        });

        if (api.data.status_code === 200) {
          toast({
            title: 'Successfully Added',
            description: api.data.message,
            status: 'success',
            duration: 3000,
            isClosable: true,
            position: 'top',
          });
          CloseModal();
          props.func();
        } else {
          throw new Error(api.data.message);
        }
      } catch (error) {
        console.log('Error', error);
        toast({
          title: 'Failed to create ticket',
          description: error.response?.data?.message || 'Unknown error',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top',
        });
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <>
      <Button
        variant='lightBrand'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        boxShadow='lg'
        px='15px'
        float='right'
        py='5px'
        onClick={onOpen}>
        {props.Icon}
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={CloseModal}
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}>
        <ModalOverlay />
        <ModalContent>
          <form
            onSubmit={formik.handleSubmit}
            noValidate>
            <ModalHeader>{props.head}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl
                isInvalid={formik.touched.subject && formik.errors.subject}
                isRequired>
                <FormLabel>Subject</FormLabel>
                <Textarea
                  ref={initialRef}
                  placeholder='Enter Subject'
                  {...formik.getFieldProps('subject')}
                />
                {formik.touched.subject && formik.errors.subject ? (
                  <Text color='red.400'>{formik.errors.subject}</Text>
                ) : null}
              </FormControl>
              <FormControl
                mt={4}
                isInvalid={formik.touched.message && formik.errors.message}
                isRequired>
                <FormLabel>Message</FormLabel>
                <Textarea
                  placeholder='Enter Message'
                  {...formik.getFieldProps('message')}
                />
                {formik.touched.message && formik.errors.message ? (
                  <Text color='red.400'>{formik.errors.message}</Text>
                ) : null}
              </FormControl>
              {!props.customerPhoneNumber && (
                <FormControl
                  mt={4}
                  isRequired
                  isInvalid={
                    formik.touched.phoneNumber && formik.errors.phoneNumber
                  }>
                  <FormLabel>Phone Number</FormLabel>
                  <Input
                    type='number'
                    placeholder='Enter Phone Number'
                    {...formik.getFieldProps('phoneNumber')}
                  />
                  {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                    <Text color='red.400'>{formik.errors.phoneNumber}</Text>
                  ) : null}
                </FormControl>
              )}
              <FormControl
                alignItems='center'
                mt={4}
                isRequired
                isInvalid={formik.touched.priority && formik.errors.priority}>
                <Flex>
                  <FormLabel>Priority</FormLabel>
                  <Select
                    id='priority'
                    {...formik.getFieldProps('priority')}>
                    <option value='LOWEST'>Low</option>
                    <option value='NORMAL'>Normal</option>
                    <option value='HIGH'>High</option>
                  </Select>
                </Flex>

                {formik.touched.priority && formik.errors.priority ? (
                  <Text color='red.400'>{formik.errors.priority}</Text>
                ) : null}
              </FormControl>

              <FormControl
                alignItems='center'
                mt={4}
                isRequired
                isInvalid={formik.touched.status && formik.errors.status}>
                <Flex>
                  <FormLabel>Status</FormLabel>
                  <Select
                    id='status'
                    {...formik.getFieldProps('status')}>
                    <option value='OPEN'>Open</option>
                    <option value='INPROGRESS'>In Progress</option>
                    <option value='CLOSED'>Closed</option>
                    <option value='RESOLVED'>Resolved</option>
                  </Select>
                </Flex>

                {formik.touched.status && formik.errors.status ? (
                  <Text color='red.400'>{formik.errors.status}</Text>
                ) : null}
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme='blue'
                mr={3}
                type='submit'
                disabled={formik.isSubmitting}>
                Save
              </Button>
              <Button onClick={CloseModal}>Cancel</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
}
